import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Header, Icon, Message, List, Form, Button } from 'semantic-ui-react';

const profileValues = {
  default: '$100 daily, $400 weekly (default)',
  Auth300: '$300 daily, no weekly limit',
  TrustedLevel1: '$150 daily, $450 weekly (trusted-level-1)',
};

export class LimitConfirmationModal extends React.Component {
  state = {}

  callApi = () => {
    const { profile } = this.state;
    const { accountId, instrumentId, onChange } = this.props;
    this.setState({ saving: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/instrument/${accountId}/${instrumentId}/set-limits`,
        catchErrors: true,
        body: { profile },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, saving: false });
      } else {
        this.setState({ opened: false, error: null, saving: false });
        onChange();
      }
    });
  }

  render() {
    const { opened, error, saving, profile } = this.state;

    return (
      <Modal
        open={opened}
        trigger={<Button onClick={() => this.setState({ opened: true })}>Change Card Limits</Button>}
      >
        <Header icon="attention" content="Change Card Limits" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot change limits on card:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          {!error && (
            <Message>
              Are you sure you want to change the default limit on this card?
              This can expose us (and the customer) to increased fraud amounts.
            </Message>
          )
          }
          <Form>
            <Form.Dropdown
              fluid
              selection
              label="Limit Type"
              text={profile ? profileValues[profile] : 'Choose a limit...'}
              options={Object.entries(profileValues).map(([k, v]) => ({ text: v, value: k }))}
              onChange={(e, { value }) => this.setState({ profile: value })}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button loading={saving} basic color="blue" onClick={this.callApi}>
            <Icon name="eye" />
            {' '}
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

LimitConfirmationModal.propTypes = {
  accountId: PT.number,
  instrumentId: PT.number,
  onChange: PT.func.isRequired,
};

LimitConfirmationModal.defaultProps = {
  instrumentId: 0,
  accountId: 0,
};
